import type { CheatRow, CombatBlock } from './types';

export function CheatStrip({
  rows,
  combat,
}: {
  rows: CheatRow[];
  combat: CombatBlock;
}) {
  return (
    <div className="card space-y-4">
      <div>
        <div className="font-display text-[11px] uppercase tracking-[0.28em] text-gold-400 mb-2">
          Most-likely rolls (the 80%)
        </div>
        <div className="grid gap-2 sm:grid-cols-2">
          {rows.map((r) => (
            <div
              key={r.label}
              className="rounded-sm border border-gold-400/20 bg-ink-800/40 p-3"
            >
              <div className="font-serif text-sm text-parchment-50">{r.label}</div>
              <div className="font-mono text-[13px] text-gold-300">{r.formula}</div>
              {r.note && <div className="text-xs muted mt-1">{r.note}</div>}
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="font-display text-[11px] uppercase tracking-[0.28em] text-gold-400 mb-2">
          Combat (last-resort)
        </div>
        <div className="grid gap-2 sm:grid-cols-2 text-[13px]">
          <div className="font-mono">
            <span className="text-gold-400 uppercase text-[10px] tracking-[0.2em] block">Init</span>
            {combat.init}
          </div>
          <div className="font-mono">
            <span className="text-gold-400 uppercase text-[10px] tracking-[0.2em] block">Attack</span>
            {combat.attack}
          </div>
          <div className="font-mono">
            <span className="text-gold-400 uppercase text-[10px] tracking-[0.2em] block">Defense</span>
            {combat.defense}
          </div>
          <div className="font-mono">
            <span className="text-gold-400 uppercase text-[10px] tracking-[0.2em] block">Damage</span>
            {combat.damage}
          </div>
          <div className="font-mono">
            <span className="text-gold-400 uppercase text-[10px] tracking-[0.2em] block">Soak</span>
            {combat.soak}
          </div>
        </div>
        {combat.notes && (
          <p className="text-xs italic muted mt-3 border-t border-gold-400/15 pt-3">
            {combat.notes}
          </p>
        )}
      </div>
    </div>
  );
}
